package com.tixforgigs.common.core.util

import com.tixforgigs.common.core.enums.ClientType
import com.tixforgigs.common.core.extensions.BuildKonfigUtil
import com.tixforgigs.common.http.HttpClient
import com.tixforgigs.common.http.HttpClient.HTTP_CLIENT
import io.opentelemetry.kotlin.ExperimentalApi
import io.opentelemetry.kotlin.OpenTelemetry
import io.opentelemetry.kotlin.createOpenTelemetry
import io.opentelemetry.kotlin.logging.export.batchLogRecordProcessor
import io.opentelemetry.kotlin.logging.export.otlpHttpLogRecordExporter
import io.opentelemetry.kotlin.semconv.IncubatingApi
import io.opentelemetry.kotlin.semconv.ServiceAttributes
import io.opentelemetry.kotlin.tracing.export.batchSpanProcessor
import io.opentelemetry.kotlin.tracing.export.otlpHttpSpanExporter

@OptIn(ExperimentalApi::class, IncubatingApi::class)
actual object Otel {

  const val OTLP_BASEURL = "https://otel.monitoring.tixforgigs.dev"

  private val engine = HTTP_CLIENT.engine
  private val sdk = initializeOtelSdk()

  val logger = sdk.loggerProvider.getLogger(serviceName(), BuildKonfigUtil.CLIENT_VERSION)

  internal actual fun initializeOtelSdk(): OpenTelemetry {
    return createOpenTelemetry(config = {
      tracerProvider {
        resource(attributes = {
          setStringAttribute(ServiceAttributes.SERVICE_NAME, serviceName())
          setStringAttribute(ServiceAttributes.SERVICE_NAMESPACE, "arai")
          setStringAttribute(ServiceAttributes.SERVICE_VERSION, BuildKonfigUtil.CLIENT_VERSION)
        })
        export {
          batchSpanProcessor(otlpHttpSpanExporter(OTLP_BASEURL, engine))
        }
      }
      loggerProvider {
        resource(attributes = {
          setStringAttribute(ServiceAttributes.SERVICE_NAME, serviceName())
          setStringAttribute(ServiceAttributes.SERVICE_NAMESPACE, "arai")
          setStringAttribute(ServiceAttributes.SERVICE_VERSION, BuildKonfigUtil.CLIENT_VERSION)
        })
        export {
          batchLogRecordProcessor(otlpHttpLogRecordExporter(OTLP_BASEURL, engine))
        }
      }
    })
  }

  private fun serviceName() = when (HttpClient.CLIENT_TYPE) {
    ClientType.ARAI_STOREFRONT -> "storefront:kmp"
    ClientType.TEMPLATE_CONFIGURATOR -> "configurator:kmp"
  }
}
